import { Connector, ConnectorSpec } from '@integration-app/sdk'
import { DefaultPageLayout, HeadMetatags } from 'routes/components/Layout'
import { IntegrationType } from 'routes/Integrations/helpers/types'
import { IntegrationPageCommonWrapper } from '../components/IntegrationPageCommonWrapper'
import {
  IntegrationMissingDataCollections,
  IntegrationMissingOperations,
} from '../components/IntegrationMissingData'
// import { Connector as ConnectorComponent } from '../components/Connector'
import { IntegrationPageLinks } from './components/IntegrationPageLinks'
import { IntegrationPageGettingStarted } from './components/IntegrationPageGettingStarted'
import { IntegrationPageOnDemandConnector } from './components/IntegrationPageOnDemandConnector'
import { IntegrationPageDataCollections } from './components/IntegrationPageDataCollections'
import { IntegrationPageOperations } from './components/IntegrationPageOperations'
import { IntegrationPageScenarios } from './components/IntegrationPageScenarios'
// import { IntegrationPageSpecifications } from './components/IntegrationPageSpecifications'
// import { IntegrationPageEvents } from './components/IntegrationPageEvents'
import common from 'routes/Integrations/Integration/Integration.module.scss'
import { IntegrationPageUdmMapping } from './components/IntegrationPageUdmMapping'

export default function IntegrationOverviewPage({
  integration,
  gettingStartedToc,
  connector,
  similarConnectors,
}: {
  integration: IntegrationType
  gettingStartedToc?: string
  connector: Connector
  similarConnectors: Array<ConnectorSpec>
}) {
  if (!integration || !integration.key) {
    return <div>Loading...</div>
  }

  const filteredDataCollections = integration.data_collections?.filter(
    (collection) => collection.type === 'collection',
  )

  const { scenarios = [] } = integration

  return (
    <DefaultPageLayout className={common.page}>
      <HeadMetatags
        title={`${integration.name} Connector for Your Product`}
        description={`Add white-label customer-facing integration with ${integration.name} into your app with just a few lines of code.`}
        type={'article'}
        canonical={`/integrations/${encodeURIComponent(integration.key.toLowerCase())}`}
      />

      <IntegrationPageCommonWrapper integration={integration}>
        <IntegrationPageLinks integration={integration} />

        <IntegrationPageGettingStarted
          integration={integration}
          gettingStartedToc={gettingStartedToc}
        />

        {integration.onDemand && <IntegrationPageOnDemandConnector />}

        {connector && !!filteredDataCollections?.length && (
          <IntegrationPageDataCollections
            dataCollections={filteredDataCollections}
          />
        )}

        {connector && !filteredDataCollections?.length && (
          <IntegrationMissingDataCollections />
        )}

        {connector && !!integration.operations?.length && (
          <IntegrationPageOperations
            integrationName={integration.name as string}
            integrationKey={integration.key as string}
            operationsAmount={integration.operations_amount as number}
          />
        )}

        {connector && !integration.operations?.length && (
          <IntegrationMissingOperations />
        )}

        {connector && !!integration.scenarios?.length && (
          <IntegrationPageScenarios
            integrationName={integration.name as string}
            integrationKey={integration.key as string}
            scenariosAmount={integration.scenarios_amount as number}
            scenarios={scenarios}
          />
        )}

        {similarConnectors?.length > 0 && (
          <IntegrationPageUdmMapping
            connector={connector}
            similarConnectors={similarConnectors}
          />
        )}

        {/*<IntegrationPageSpecifications />*/}
        {/*<IntegrationPageEvents />*/}
      </IntegrationPageCommonWrapper>
    </DefaultPageLayout>
  )
}
